export default class BallBankRun {
  #roadName;
  #vicinity;
  #comment;
  #date;
  #curves;

  constructor(roadName, vicinity, comment, date) {
    this.#roadName = roadName;
    this.#vicinity = vicinity;
    this.#comment = comment;
    this.#date = date;
    this.#curves = [];
  }

  get roadName() {
    return this.#roadName;
  }
  get vicinity() {
    return this.#vicinity;
  }
  get comment() {
    return this.#comment;
  }
  get date() {
    return this.#date;
  }
  get curves() {
    return this.#curves;
  }

  getFlattenedRun() {
    return this.curves.flatMap((c) =>
      c.points.map((pt) => ({
        coordinates: { latitude: pt.latitude, longitude: pt.longitude },
        attributes: {
          curve_date: this.#date,
          road_name: this.#roadName,
          vicinity: this.#vicinity,
          comment: this.#vicinity,
          LR: c.curveType,
          ball_bank: pt.ballBank,
          test_speed: pt.testSpeed,
          advisory_speed: c.advisorySpeed,
          fromFile: true,
        },
      }))
    );
  }
}

export class Curve {
  #curveType;
  #points;
  constructor(curveType) {
    this.#curveType = curveType;
    this.#points = [];
  }

  get curveType() {
    return this.#curveType;
  }
  get points() {
    return this.#points;
  }

  /**
   * adjusts the output safespeed to the nearest valid speed limit
   * eg. 66, 67, 68 => 65km/h, 69 => 70km/h
   */
  get advisorySpeed() {
    let result = this.minSpeedPoint.safeSpeed;
    switch (result % 5) {
      case 0:
        break;
      case 1:
      case 2:
      case 3:
        result -= result % 5;
        break;
      case 4:
        result++;
        break;
      default:
        break;
    }
    return result;
  }

  /**
   * returns the point data object with the minimum safe speed value on this curve
   */
  get minSpeedPoint() {
    const safeSpeed = Math.min(...this.#points.map((pt) => pt.safeSpeed));
    return this.#points.find((minPoint) => minPoint.safeSpeed === safeSpeed);
  }
}

export class PointData {
  #ballBank;
  #refDist;
  #testSpeed;
  #latitude;
  #longitude;
  constructor(ballBank, refDist, testSpeed, latitude, longitude) {
    this.#ballBank = ballBank;
    this.#refDist = refDist;
    this.#testSpeed = testSpeed;
    this.#latitude = latitude;
    this.#longitude = longitude;
  }

  get ballBank() {
    return this.#ballBank;
  }
  get refDist() {
    return this.#refDist;
  }
  get testSpeed() {
    return this.#testSpeed;
  }
  get latitude() {
    return this.#latitude;
  }
  get longitude() {
    return this.#longitude;
  }

  /**
   * calculates the safe speed at this point
   */
  get safeSpeed() {
    return Math.round(
      ((Math.sqrt((this.#ballBank + 3) * 6000 + Math.pow(this.#testSpeed, 2)) -
        this.#testSpeed) /
        (16 * (this.#ballBank + 3))) *
        this.#testSpeed
    );
  }
}
